export const DIMENSION_OPTIONS = [
  { label: '120x600', value: '120x600' },
  { label: '160x600', value: '160x600' },
  { label: '180x150', value: '180x150' },
  { label: '200x600', value: '200x600' },
  { label: '234x60', value: '234x60' },
  { label: '300x50', value: '300x50' },
  { label: '300x250', value: '300x250' },
  { label: '300x600', value: '300x600' },
  { label: '320x50', value: '320x50' },
  { label: '320x100', value: '320x100' },
  { label: '336x280', value: '336x280' },
  { label: '468x60', value: '468x60' },
  { label: '640x360', value: '640x360' },
  { label: '640x480', value: '640x480' },
  { label: '728x90', value: '728x90' },
  { label: '800x250', value: '800x250' },
  { label: '970x90', value: '970x90' },
  { label: '970x250', value: '970x250' },
  { label: '1280x720', value: '1280x720' },
  { label: '1920x1080', value: '1920x1080' }
];
